import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Mic on SVG Icon for mic control button.
 */
export const MicOn: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 35 35"
    aria-hidden={true}
    {...props}
  >
    <path
      d="M17.6771 22.3793C20.6089 22.3793 22.8572 20.1766 22.8572 16.9258V7.21875C22.8572 3.96788 20.6089 1.75 17.6771 1.75C14.73 1.75 12.4666 3.96788 12.4666 7.21875V16.9258C12.4666 20.1766 14.73 22.3793 17.6771 22.3793ZM6.375 17.3056C6.375 23.3819 10.4462 27.4987 16.2187 28.076V30.8103H10.9779C10.1424 30.8103 9.45877 31.4787 9.45877 32.299C9.45877 33.1194 10.1424 33.803 10.9779 33.803H24.3763C25.1966 33.803 25.8954 33.1194 25.8954 32.299C25.8954 31.4787 25.1966 30.8103 24.3763 30.8103H19.1202V28.076C24.908 27.4987 28.964 23.3819 28.964 17.3056V14.5104C28.964 13.6749 28.2956 13.0369 27.4601 13.0369C26.6246 13.0369 25.941 13.6749 25.941 14.5104V17.1992C25.941 22.0907 22.5534 25.3112 17.6771 25.3112C12.7856 25.3112 9.398 22.0907 9.398 17.1992V14.5104C9.398 13.6749 8.71441 13.0369 7.87891 13.0369C7.05859 13.0369 6.375 13.6749 6.375 14.5104V17.3056Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
